import React, { useEffect } from 'react'
import Aos from 'aos'
import "aos/dist/aos.css";
import LazyLoad from './LazyLoad'
import OurServiceCard from './OurServiceCard'

// Icons from react-icons
import { FaUsers, FaHandshake, FaChartLine, FaDollarSign } from 'react-icons/fa';

export const services_data = [
  {
    title: "Build Your Digital Presence Like You Build Projects",
    img: "https://images.pexels.com/photos/159306/construction-site-build-construction-work-159306.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750",
    subtitle: (
      <div>
        Your website isn’t just a profile—it’s your firm’s online storefront and trust builder. We create high-impact, mobile-optimised sites tailored to the construction industry.<br />
        Feature-rich designs with project portfolios, testimonials, and certifications<br />
        Mobile-first builds that load fast and rank high on Google<br />
        Smart contact forms and real-time enquiry tracking to turn visitors into leads
      </div>
    ),
    icon: <FaUsers />
  },
  {
    title: "Smart Project Management Tools – Control the Chaos",
    img: "https://images.pexels.com/photos/1750392/pexels-photo-1750392.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750",
    subtitle: (
      <div>
        Construction is complex—your systems shouldn’t be. Our digital platforms bring structure and visibility to every stage of the build.<br />
        Visual timelines, task delegation, and milestone tracking<br />
        Centralised document storage with version control<br />
        Role-based dashboards for teams, contractors, and clients
      </div>
    ),
    icon: <FaHandshake />
  },
  {
    title: "Quoting, Estimating & Invoicing – Win Faster",
    img: "https://images.pexels.com/photos/3183197/pexels-photo-3183197.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750",
    subtitle: (
      <div>
        Stop chasing spreadsheets. Win more work with fast, accurate quotes, and automate your invoicing from day one.<br />
        Live cost calculators with updated material/labour pricing<br />
        Digital quote approvals and instant change order adjustments
      </div>
    ),
    icon: <FaChartLine />
  },
  {
    title: "Field-to-Office Connectivity – Stay in Control",
    img: "https://images.pexels.com/photos/585419/pexels-photo-585419.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750",
    subtitle: (
      <div>
        Stay in control, even when you're not on-site. Our mobile tools connect your site teams, managers, and clients in real time.<br />
        On-site reporting and photo uploads from mobile<br />
        Daily logs, progress tracking, and live communication feeds<br />
        Issue flagging and resolution workflows to avoid delays
      </div>
    ),
    icon: <FaDollarSign />
  }
];

const OurServices = () => {
  useEffect(() => {
    Aos.init({
      offset: 200,
      duration: 800,
      once: true,
    })
  }, [])

  return (
    <section className='pt-5' style={{ background: 'linear-gradient(135deg, #ffffff 0%, #ff8c00 100%)' }} id='our-services'>
      <div className='auto-container py-md-5'>
        <div className='text-center mb-4'>
          <h2 className='text-red fw-bold' style={{ background: 'linear-gradient(90deg, #ff8c00, #ffa726)', WebkitBackgroundClip: 'text', WebkitTextFillColor: 'transparent' }}>
            Our Services for the Construction Industry
          </h2>
          <h2 className='text-red fw-bold' style={{ background: 'linear-gradient(90deg, #ff8c00, #ffa726)', WebkitBackgroundClip: 'text', WebkitTextFillColor: 'transparent' }}>
          
          </h2>
        </div>
        <LazyLoad>
          <div className='mt-4'>
            <div className="row align-items-center" >
              {services_data.map((service, i) => (
                <OurServiceCard key={i} service={service} />
              ))}
            </div>
          </div>
        </LazyLoad>
      </div>
    </section>
  )
}

export default OurServices;